import { BrowserRouter as Router, Route, Navigate , Routes } from 'react-router-dom';
import Login from './components/Admin/Login';
import Admin from './components/Admin/Admin';
import HomePage from './HomePage';
import PrivateRoute from './PrivateRoute';

function App() {
  return (
    <Router>
    <Routes>
      {/* Route for the admin login page */}
      <Route path="/admin/login" element={<Login />} />
      
      {/* Protected route for admin dashboard */}
      <Route path="/admin/dashboard" element={<PrivateRoute><Admin /></PrivateRoute>} />
      
      {/* Redirect from /admin to /admin/login if accessed without login */}
      <Route path="/admin" element={<Navigate to="/admin/login" />} />
      
      {/* Define a route for the homepage if needed */}
      <Route path="/" element={<HomePage />} />
    </Routes>
  </Router>
  );
}

export default App;
